import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { buildSnackbarButton } from '@/ui/components/snackbar/SnackbarButton';
import { translate } from '@/ui/i18n';

import { ProjectExportReportProjectGateway } from '../../gateways/export-report-project.gateway';
import { ExportReportProjectActionParams } from '../export-report-project.action';

export async function exportPdf(
  projectExportReportGateway: ProjectExportReportProjectGateway,
  snackbarGateway: SnackbarGateway,
  params: ExportReportProjectActionParams,
): Promise<void> {
  try {
    const pdfUrl = await projectExportReportGateway.exportPdfReport(params);
    showSnackbarSuccess(snackbarGateway, pdfUrl);
  } catch (error: unknown) {
    const message = error instanceof Error ? error.message : undefined;
    showSnackbarError(snackbarGateway, message);
    throw error;
  }
}

function showSnackbarSuccess(snackbarGateway: SnackbarGateway, url: string) {
  const action = {
    title: translate('ReportExporter.open-preview'),
    onClick: () => window.open(url, '_blank'),
  };
  snackbarGateway.success(translate('ReportExporter.Message.success'), {
    action: buildSnackbarButton(action.title, action.onClick),
    autoHideDuration: 6_000,
  });
}

function showSnackbarError(snackbarGateway: SnackbarGateway, message?: string) {
  snackbarGateway.error(
    translate('ReportExporter.Message.error', { message }),
    { autoHideDuration: 6_000 },
  );
}
